// Autogenerated file
export const bidChatDomainTypesEnum = {
    Default: "Default",
    Rate: "Rate",
    Secondary: "Secondary",
    Documents: "Documents",
    DriverNotifications: "DriverNotifications",
};
export const bidChatDomainTypes = [
    { label: "Заявка", value: "Default" },
    { label: "Ставка", value: "Rate" },
    { label: "Дополнительный", value: "Secondary" },
    { label: "Документы заявки", value: "Documents" },
    { label: "Уведомления водителя", value: "DriverNotifications" },
];
